import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PaperApprovalStatus, PaperSubmissionSummaryViewModel } from 'src/app/_models/generatedModels';
import { UserService } from 'src/app/_services/generatedServices';
import { ToasterService } from 'src/app/_services/toaster.service';

@Component({
  selector: 'bxl-my-paper-submissions',
  templateUrl: 'my-paper-submissions.component.html',
})
export class MyPaperSubmissionsComponent implements OnInit {
  initialized = false;
  papers: PaperSubmissionSummaryViewModel[];
  PaperApprovalStatus: PaperApprovalStatus;
  constructor(private route: ActivatedRoute, private userService: UserService, private toaster: ToasterService) {}

  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      this.userService.getPaperSubmissions().subscribe((result) => {
        this.papers = result;
        this.initialized = true;
      });
    });
  }

  delete(paper: PaperSubmissionSummaryViewModel){
    this.toaster.confirmDialog('Are you sure you want to delete this draft?', 'Are you sure?').subscribe((confirm) => {
      if (confirm) {
        this.userService.deletePaperDraft(paper.id).subscribe(result=>{
          this.ngOnInit();
        });
      }
    });

  }
}
